import {
    ALL,
    ALL_PATH,
    COMMUNITY,
    COMMUNITY_FAQ,
    COMMUNITY_FAQ_ADD,
    COMMUNITY_FAQ_DETAIL,
    COMMUNITY_FAQ_EDIT,
    COMMUNITY_FAQ_PATH,
    COMMUNITY_NOTICE,
    COMMUNITY_NOTICE_ADD,
    COMMUNITY_NOTICE_ADD_PATH,
    COMMUNITY_NOTICE_DETAIL,
    COMMUNITY_NOTICE_DETAIL_PATH,
    COMMUNITY_NOTICE_EDIT,
    COMMUNITY_NOTICE_EDIT_PATH,
    COMMUNITY_NOTICE_PATH,
    COMMUNITY_PATH,
    COMMUNITY_QNA,
    COMMUNITY_QNA_ADD,
    COMMUNITY_QNA_DETAIL,
    COMMUNITY_QNA_EDIT,
    COMMUNITY_QNA_PATH,
    ENROLMENT,
    ENROLMENT_ENROLMENT_RESULT,
    ENROLMENT_ENROLMENT_RESULT_PATH,
    ENROLMENT_PATH,
    ENROLMENT_SCHEDULE_TABLE,
    ENROLMENT_SCHEDULE_TABLE_PATH,
    ENROLMENT_SEARCH_SUBJECT,
    ENROLMENT_SEARCH_SUBJECT_PATH,
    FIND_ID_PW_PATH,
    JOIN_US_PATH,
    LOGIN_PATH,
    MAIN,
    MAIN_PATH,
    PAGE_404_PATH,
    PAGE_500_PATH,
    PASSWORD_RESET_PATH,
    ROLE,
    ROOT,
    SEMESTER,
    SEMESTER_ENROLMENT_STATUS,
    SEMESTER_ENROLMENT_STATUS_PATH,
    SEMESTER_TOTAL_ENROLMENT_STATUS,
    SEMESTER_ENROLMENT_MANAGEMENT,
    SEMESTER_PATH,
    SEMESTER_STUDENT_ENROLMENT_CHECK,
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH,
    SEMESTER_STUDENT_UNIVERSITY,
    SEMESTER_STUDENT_UNIVERSITY_PATH,
    SEMESTER_SUBJECT,
    SEMESTER_SUBJECT_PATH,
    SUBJECT_SEARCH,
    SUBJECT_SEARCH_BODY,
    SUBJECT_SEARCH_BODY_PATH,
    SUBJECT_SEARCH_PATH,
    SYSTEM,
    SYSTEM_COMMON_CODE,
    SYSTEM_COMMON_CODE_PATH,
    SYSTEM_LOGIN_HISTORY,
    SYSTEM_PATH,
    SYSTEM_SUBJECT_CODE,
    SYSTEM_SUBJECT_CODE_PATH,
    SYSTEM_TERM,
    SYSTEM_TERM_PATH,
    SYSTEM_ENROLMENT_NOTICE,
    SYSTEM_ENROLMENT_NOTICE_PATH,
    SYSTEM_UNIVERSITY,
    SYSTEM_UNIVERSITY_MANAGER,
    SYSTEM_UNIVERSITY_MANAGER_PATH,
    SYSTEM_USER,
    SYSTEM_USER_PATH,
    SMS,
    SMS_PATH,
    SMS_SEND,
    SMS_HISTORY,
    SMS_SEND_PATH,
    TEST_MODAL,
    TEST_MODAL_PATH,
    TEST_PATH,
    USER_INFO,
    USER_INFO_PATH,
} from '../constant/Constant';
import CommunityFaqView from '../view/body/community/faq/CommunityFaqView';
import CommunityNoticeView from '../view/body/community/notice/CommunityNoticeView';
import CommunityQnaView from '../view/body/community/qna/CommunityQnaView';
import EnrolmentEnrolmentResultView from '../view/body/enrolment/EnrolmentEnrolmentResultView';
import EnrolmentScheduleTableView from '../view/body/enrolment/EnrolmentScheduleTableView';
import EnrolmentSearchSubjectView from '../view/body/enrolment/EnrolmentSearchSubjectView';
import SemesterEnrlmentStatusView from '../view/body/semester/SemesterEnrolmentStatusView';
import SemesterTotalEnrolmentStatusView from '../view/body/semester/SemesterTotalEnrolmentStatusView';
import SemesterStudentEnrolmentCheckView from '../view/body/semester/SemesterStudentEnrolmentCheckView';
import SemesterStudentUniversityView from '../view/body/semester/SemesterStudentUniversityView';
import SemesterSubjectView from '../view/body/semester/SemesterSubjectView';
import SemesterEnrolmentManagementView from '../view/body/semester/SemesterEnrolmentManagementView';
import SystemCommonCodeView from '../view/body/system/SystemCommonCodeView';
import SystemSubjectCodeView from '../view/body/system/SystemSubjectCodeView';
import SystemTermView from '../view/body/system/SystemTermView';
import SystemEnrolmentNotice from '../view/body/system/SystemEnrolmentNoticeView';
import SystemUniversityManagerView from '../view/body/system/SystemUniversityManagerView';
import SystemUniversityView from '../view/body/system/SystemUniversityView';
import SystemUserView from '../view/body/system/SystemUserView';
import Page404View from '../view/body/main/Page404View';
import LoginView from '../view/body/main/LoginView';
import SemesterRouterView from '../view/body/semester/SemesterRouterView';
import SystemRouterView from '../view/body/system/SystemRouterView';
import EnrolmentRouterView from '../view/body/enrolment/EnrolmentRouterView';
import CommunityRouterView from '../view/body/community/CommunityRouterView';
import MainView from '../view/body/main/MainView';
import SubjectSearchView from '../view/body/subject/SubjectSearchView';
import SubjectSearchRouterView from '../view/body/subject/SubjectSearchRouterView';
import JoinUsView from '../view/body/main/JoinUsView';
import FindPwView from '../view/body/main/FindIdPwView';
import DefaultPathView from '../view/DefaultPathView';
import CommunityNoticeAddView from '../view/body/community/notice/CommunityNoticeAddView';
import CommunityNoticeDetailView from '../view/body/community/notice/CommunityNoticeDetailView';
import CommunityNoticeEditView from '../view/body/community/notice/CommunityNoticeEditView';
import CommunityNoticeRouterView from '../view/body/community/notice/CommunityNoticeRouterView';
import CommunityFaqDetailView from '../view/body/community/faq/CommunityFaqDetailView';
import CommunityFaqAddView from '../view/body/community/faq/CommunityFaqAddView';
import CommunityFaqEditView from '../view/body/community/faq/CommunityFaqEditView';
import CommunityQnaAddView from '../view/body/community/qna/CommunityQnaAddView';
import CommunityQnaDetailView from '../view/body/community/qna/CommunityQnaDetailView';
import CommunityQnaEditView from '../view/body/community/qna/CommunityQnaEditView';
import CommunityFaqRouterView from '../view/body/community/faq/CommunityFaqRouterView';
import CommunityQnaRouterView from '../view/body/community/qna/CommunityQnaRouterView';
import PasswordReset from '../view/body/main/PasswordResetView';
import UserInfoView from '../view/body/main/UserInfoView';
import TestModalView from '../view/body/test/TestModalView';
import TestRouterView from '../view/body/test/TestRouterView';
import SystemLoginHistoryView from '../view/body/system/SystemLoginHistoryView';
import SmsRouterView from '../view/body/sms/SmsRouterView';
import SmsSendView from '../view/body/sms/SmsSendView';
import SmsHistoryView from '../view/body/sms/SmsHistoryView';

export let RootRouter = [
    // 기본화면 이동
    // TODO 테스트용 삭제처리
    { path: TEST_PATH, element: <DefaultPathView path={TEST_MODAL_PATH} /> },
    { path: SYSTEM_PATH, element: <DefaultPathView path={SYSTEM_TERM_PATH} /> },
    { path: SEMESTER_PATH, element: <DefaultPathView path={SEMESTER_SUBJECT_PATH} /> },
    { path: ENROLMENT_PATH, element: <DefaultPathView path={ENROLMENT_SEARCH_SUBJECT_PATH} /> },
    { path: SUBJECT_SEARCH_PATH, element: <DefaultPathView path={SUBJECT_SEARCH_BODY_PATH} /> },
    { path: COMMUNITY_PATH, element: <DefaultPathView path={COMMUNITY_NOTICE_PATH} /> },
    { path: SMS_PATH, element: <DefaultPathView path={SMS_SEND_PATH} /> },

    // 하위 Router 이동
    // TODO 테스트용 삭제처리
    { path: TEST_PATH + ALL_PATH, element: <TestRouterView /> },
    { path: SYSTEM_PATH + ALL_PATH, element: <SystemRouterView /> },
    { path: SEMESTER_PATH + ALL_PATH, element: <SemesterRouterView /> },
    { path: ENROLMENT_PATH + ALL_PATH, element: <EnrolmentRouterView /> },
    { path: SUBJECT_SEARCH_PATH + ALL_PATH, element: <SubjectSearchRouterView /> },
    { path: COMMUNITY_PATH + ALL_PATH, element: <CommunityRouterView /> },
    { path: SMS_PATH + ALL_PATH, element: <SmsRouterView /> },

    { path: JOIN_US_PATH + '/:phase', element: <JoinUsView /> },
    { path: PASSWORD_RESET_PATH + ALL_PATH, element: <PasswordReset /> },
    { path: USER_INFO_PATH + ALL_PATH, element: <UserInfoView /> },

    { path: LOGIN_PATH, element: <LoginView /> },
    { path: FIND_ID_PW_PATH, element: <FindPwView /> },
    { path: MAIN_PATH, element: <MainView /> },
    { path: PAGE_404_PATH, element: <Page404View /> },
    { path: MAIN + ALL_PATH, element: <Page404View /> },
];

// TODO 테스트용 삭제처리
export let TestRouter = [
    { path: TEST_MODAL, element: <TestModalView /> },
    { path: ALL, element: <Page404View /> },
];

export let SmsRouter = [
    { path: SMS_SEND, element: <SmsSendView /> },
    { path: SMS_HISTORY, element: <SmsHistoryView /> },
    { path: ALL, element: <Page404View /> },
];

export let SystemRouter = [
    { path: SYSTEM_TERM, element: <SystemTermView /> },
    { path: SYSTEM_ENROLMENT_NOTICE, element: <SystemEnrolmentNotice /> },
    { path: SYSTEM_SUBJECT_CODE, element: <SystemSubjectCodeView /> },
    { path: SYSTEM_COMMON_CODE, element: <SystemCommonCodeView /> },
    { path: SYSTEM_UNIVERSITY, element: <SystemUniversityView /> },
    { path: SYSTEM_UNIVERSITY_MANAGER, element: <SystemUniversityManagerView /> },
    { path: SYSTEM_USER, element: <SystemUserView /> },
    { path: SYSTEM_LOGIN_HISTORY, element: <SystemLoginHistoryView /> },
    { path: ALL, element: <Page404View /> },
];

export let SemesterRouter = [
    { path: SEMESTER_SUBJECT, element: <SemesterSubjectView /> },
    { path: SEMESTER_STUDENT_UNIVERSITY, element: <SemesterStudentUniversityView /> },
    { path: SEMESTER_STUDENT_ENROLMENT_CHECK, element: <SemesterStudentEnrolmentCheckView /> },
    { path: SEMESTER_ENROLMENT_STATUS, element: <SemesterEnrlmentStatusView /> },
    { path: SEMESTER_TOTAL_ENROLMENT_STATUS, element: <SemesterTotalEnrolmentStatusView /> },
    { path: SEMESTER_ENROLMENT_MANAGEMENT, element: <SemesterEnrolmentManagementView /> },
    { path: ALL, element: <Page404View /> },
];

export let EnrolmentRouter = [
    { path: ENROLMENT_SEARCH_SUBJECT, element: <EnrolmentSearchSubjectView /> },
    { path: ENROLMENT_ENROLMENT_RESULT, element: <EnrolmentEnrolmentResultView /> },
    { path: ENROLMENT_SCHEDULE_TABLE, element: <EnrolmentScheduleTableView /> },
    { path: ALL, element: <Page404View /> },
];

export let SubjectSearchRouter = [
    { path: SUBJECT_SEARCH_BODY, element: <SubjectSearchView /> },
    { path: ALL, element: <Page404View /> },
];

export let CommunityRouter = [
    { path: COMMUNITY_NOTICE + ALL_PATH, element: <CommunityNoticeRouterView /> },
    { path: COMMUNITY_FAQ + ALL_PATH, element: <CommunityFaqRouterView /> },
    { path: COMMUNITY_QNA + ALL_PATH, element: <CommunityQnaRouterView /> },
    { path: ALL, element: <Page404View /> },
];

export let CommunityNoticeRouter = [
    { path: COMMUNITY_NOTICE_ADD, element: <CommunityNoticeAddView /> },
    {
        path: COMMUNITY_NOTICE_DETAIL,
        element: <CommunityNoticeDetailView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityNoticeDetailView />,
            },
        ],
    },
    {
        path: COMMUNITY_NOTICE_EDIT,
        element: <CommunityNoticeEditView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityNoticeEditView />,
            },
        ],
    },
    { path: ROOT, element: <CommunityNoticeView /> },
    { path: ALL, element: <Page404View /> },
];

export let CommunityFaqRouter = [
    { path: COMMUNITY_FAQ_ADD, element: <CommunityFaqAddView /> },
    {
        path: COMMUNITY_FAQ_DETAIL,
        element: <CommunityFaqDetailView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityFaqDetailView />,
            },
        ],
    },
    {
        path: COMMUNITY_FAQ_EDIT,
        element: <CommunityFaqEditView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityFaqEditView />,
            },
        ],
    },
    { path: ROOT, element: <CommunityFaqView /> },
    { path: ALL, element: <Page404View /> },
];

export let CommunityQnaRouter = [
    { path: COMMUNITY_QNA_ADD, element: <CommunityQnaAddView /> },
    {
        path: COMMUNITY_QNA_DETAIL,
        element: <CommunityQnaDetailView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityQnaDetailView />,
            },
        ],
    },
    {
        path: COMMUNITY_QNA_EDIT,
        element: <CommunityQnaEditView />,
        children: [
            {
                path: ':postingNo',
                element: <CommunityQnaEditView />,
            },
        ],
    },
    { path: ROOT, element: <CommunityQnaView /> },
    { path: ALL, element: <Page404View /> },
];
